import { ITreeNode } from "../../../../../libs/ts/WorkflowTree/Nodes/ITreeNode"
import { JbpTreeNodeData } from "../treeExtensions/JbpTreeNodeData";
import { IJbpChildNodeRelationship } from "../treeExtensions/IJbpChildNodeRelationship";

export abstract class IViewFactory {
    public abstract MakeView(node: ITreeNode<JbpTreeNodeData, IJbpChildNodeRelationship>, mpan: string, serviceLine: string): JSX.Element
}
